<div class="grid-wrapper auto-grid">
  @for (subCategory of category.subCategories; track $index) {
    @for (eduContentSearch of subCategory.contents; track eduContentSearch.eduContent.id) {
      <campus-edu-content-result-loader [eduContentId]="eduContentSearch.eduContent.id">
        <campus-toc-result-grid-item
          [data]="eduContentSearch"
          [selected]="eduContentSearch.checked"
          [inBasket]="eduContentSearch.inBasket"
          (selectionChange)="onEduContentSelectionChange($event)"
        ></campus-toc-result-grid-item>
      </campus-edu-content-result-loader>
    }
  }
</div>
